module.exports = {
    shopifyLogo: null
}